var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('CategorySidebar'),_c('CardSection',{attrs:{"sortable":true,"title":_vm.title,"recipes":_vm.recipes,"card-limit":9999},on:{"sort":_vm.sortAZ,"sort-recent":_vm.sortRecent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }